export default __webpack_public_path__ + "static/media/vimeo_yds_intro.62e88e61.webp";